import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { useCommonBenchmarks } from 'hooks/useCommonBenchmarks';
import CheckboxButton from 'components/buttons/CheckboxButton';
import BenchmarkInput from '../../components/BenchmarkInput';

const BenchmarkSection = ({ objectState, dispatchUpdate, actions, isDashboard, isLoading }) => {
  const { shouldInheritBenchmarks, benchmarks } = objectState;
  const [isBenchmarkAdvancedSearch, setIsBenchmarkAdvancedSearch] = useState();

  const [, filteredBenchmarks, addToResults] = useCommonBenchmarks(benchmarks);

  const handleAdvancedBenchmarkToggle = id => {
    setIsBenchmarkAdvancedSearch(id);
  };

  const handleBenchmarksObjectIdChange = selected => {
    const { type, value, label } = selected;

    dispatchUpdate({
      type: actions.UPDATE_BENCHMARK,
      payload: {
        name: label,
        benchmarkId: value,
        id: type,
        isVisible: !!value
      }
    });
  };

  const handleAddBenchmark = () => {
    dispatchUpdate({
      type: actions.UPDATE_BENCHMARK_VISIBILITY
    });
  };

  const onBenchmarkChanged = (updatedBenchmark, index) => {
    const dropdownOptionExists = filteredBenchmarks.some(
      fb => fb.label === updatedBenchmark.name && fb.value === updatedBenchmark.timeSerieId
    );
    const itemToAdd = {
      name: updatedBenchmark.name,
      benchmarkId: updatedBenchmark.id || updatedBenchmark.timeSerieId,
      id: index,
      isVisible: !!updatedBenchmark.name
    };

    if (!dropdownOptionExists) {
      addToResults(itemToAdd);
    }

    dispatchUpdate({
      type: actions.UPDATE_BENCHMARK,
      payload: itemToAdd
    });
  };

  const handleInheritBenchmarks = () => {
    setIsBenchmarkAdvancedSearch();

    dispatchUpdate({
      type: actions.UPDATED_WIDGET,
      payload: {
        shouldInheritBenchmarks: !shouldInheritBenchmarks
      }
    });
  };

  return (
    <Grid
      item
      container
      direction="row"
      justify="space-between"
      alignItems="flex-start"
      xs={12}
      md={12}
      spacing={2}
    >
      <Grid item xs={12}>
        <h3 style={{ marginTop: '0', marginBottom: 0, opacity: '0.7' }}>
          Override Default Benchmarks
        </h3>
      </Grid>

      {!isDashboard && (
        <Grid item xs={12}>
          <CheckboxButton
            title="Should the widget inherit the dashboard benchmarks"
            checked={shouldInheritBenchmarks}
            onChange={handleInheritBenchmarks}
            name="shouldInheritBenchmarks"
            hasTransparentBg
          />
        </Grid>
      )}

      {filteredBenchmarks &&
        filteredBenchmarks.length > 0 &&
        benchmarks.map(benchmark => (
          <BenchmarkInput
            key={benchmark.id}
            objectIdState={benchmark.benchmarkId}
            id={benchmark.id}
            isOpen={isBenchmarkAdvancedSearch === benchmark.id}
            options={[
              { label: benchmark.name, value: benchmark.benchmarkId },
              ...filteredBenchmarks
            ]}
            handleBenchmarksObjectIdChange={handleBenchmarksObjectIdChange}
            handleAdvancedBenchmarkToggle={handleAdvancedBenchmarkToggle}
            onBenchmarkChanged={onBenchmarkChanged}
            disabled={shouldInheritBenchmarks}
            isVisible={benchmark.isVisible}
          />
        ))}

      <Box my={1}>
        {!benchmarks[benchmarks.length - 1].isVisible && !isLoading && !shouldInheritBenchmarks && (
          <Button
            variant="outlined"
            style={{ marginLeft: '8px', textTransform: 'none' }}
            color="primary"
            size="medium"
            onClick={handleAddBenchmark}
            startIcon={<AddCircleOutlinedIcon />}
          >
            Add benchmark
          </Button>
        )}
      </Box>
    </Grid>
  );
};

BenchmarkSection.propTypes = {
  objectState: PropTypes.shape({
    shouldInheritBenchmarks: PropTypes.bool,
    benchmarks: PropTypes.arrayOf(
      PropTypes.shape({
        benchmarkId: PropTypes.number,
        name: PropTypes.string,
        id: PropTypes.string,
        isVisible: PropTypes.bool
      })
    )
  }),
  dispatchUpdate: PropTypes.func,
  actions: PropTypes.shape({
    UPDATED_WIDGET: PropTypes.string,
    UPDATE_BENCHMARK_VISIBILITY: PropTypes.string,
    UPDATE_BENCHMARK: PropTypes.string
  }),
  isLoading: PropTypes.bool,
  isDashboard: PropTypes.bool
};

BenchmarkSection.defaultProps = {
  objectState: {},
  dispatchUpdate: null,
  isLoading: false,
  isDashboard: false,
  actions: {}
};
export default BenchmarkSection;
